
<template>
  <div>
    <apexchart type="pie" :options="options" :series="series" />
  </div>
</template>

<script>
export default {
  props: {
    dataInventory: Array
  },
  watch: {
    dataInventory: {
      handler(val) {
        if (val) {
          this.series = this.dataInventory.map(i => i.product)
          this.options = {
            chart: {
              type: 'pie',
            },
            labels: this.dataInventory.map(i => i.name.toUpperCase()),
            colors: ['#0d47a1', '#666666', '#FB312F', '#222222', '#0288D0', '#FB312F', '#FF781A', '#c0c0c0'],
            dataLabels: {
              enabled: false,
            },
            legend: {
              position: 'bottom'
            },
          }
        }
      },
      deep: true
    },
  },
  data() {
    return {
      options: {},
      series: []
    }
  },
}
</script>
